module.exports = __webpack_public_path__ + "dist/assets/img/J.3ccc95cc.svg";